export { getRepeaterCells } from './getRepeaterCells'
export { getNextCell, getNextCellByPosition } from './getNextCell'

export const supportedKeyboardKeys = ['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight', 'Home', 'End']

export type IdIndexMapType = Record<string, { row: number; column: number }>
export type CellPositionType = { row: number; column: number }
export type CellIndexMapType = Map<HTMLElement, CellPositionType>
export type CellsMapType = Array<Array<HTMLElement>>
